import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const ToolbarContainer = styled.div({
  display: 'flex',
  position: 'relative',
  overflow: 'hidden',
  alignItems: 'center',
  paddingTop: token('space.100'),
  paddingBottom: token('space.100'),
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
  columnGap: '100px',
  overflowX: 'auto',
  marginRight: token('space.100'),
  marginLeft: token('space.100'),
  paddingLeft: token('space.025'),
  paddingRight: token('space.025'),
  '& > h2': {
    marginRight: token('space.050'),
    minWidth: 0,
  },
  '& > .expand': {
    flexGrow: 1,
  },
  '& > :last-child': {
    flexShrink: 0,
  },
});

export const ToolbarInnerContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  columnGap: token('space.050', '4px'),
  overflow: 'auto',
  flexShrink: 1,
  minWidth: '250px',
  width: '100%',
  '& > div:first-child': {
    flexShrink: 1,
    minWidth: 0,
    overflow: 'hidden',
  },
});

export const NativeEmbedToolbarWrapper = styled.div({
  marginLeft: token('space.400'),
});
